import rest from "../script/rest";

class EntryRest {

    async getLazy(from, pageSize, searchStr, owner) {
        const url = "/rest/entry/getLazy"
            + "?from=" + from
            + "&pageSize=" + pageSize
            + "&searchStr=" + encodeURIComponent(searchStr ?? "")
            + "&ownership=" + owner;
        const response = await rest.get(url);
        return response.json();
    }

    async getById(entryId) {
        const url = "/rest/entry/getById"
            + "?entryId=" + entryId;
        const response = await rest.get(url);
        return response.json();
    }

    async duplicate(entryId, withPlan) {
        const url = "/rest/entry/duplicate"
            + "?entryId=" + entryId
            + "&withPlan=" + withPlan;
        const response = await rest.get(url);
        const duplicateId = await response.json();
        return duplicateId.value;
    }

    async duplicateApplyWorstcase(entryId, worstcaseCalculationId) {
        const url = "/rest/entry/duplicateApplyWorstcase"
            + "?entryId=" + entryId
            + "&worstcaseCalculationId=" + worstcaseCalculationId;
        const response = await rest.get(url);
        const duplicateId = await response.json();
        return duplicateId.value;
    }

    async insert(entry) {
        const url = "/rest/entry/insert";
        const response = await rest.post(url, entry);
        return response.json();
    }

    async update(entry) {
        const url = "/rest/entry/update";
        const response = await rest.post(url, entry);
        return response.json();
    }

    async deleteById(entryId) {
        const url = "/rest/entry/deleteById"
            + "?entryId=" + entryId;
        await rest.get(url);
    }
}
const entryRest = new EntryRest();
window.entryRest = entryRest;
export default entryRest;